import { Component, ChangeDetectionStrategy, input } from '@angular/core'
import { Router } from '@angular/router'
import { TranslocoDirective } from '@jsverse/transloco'
import { appPages } from '@/routes/app-pages'
import { SiteConfigService } from '@/services/site-config.service'
import { BaseButtonComponent } from '@/shared/components/base/base-button/base-button.component'

@Component({
	selector: 'register-button',
	imports: [BaseButtonComponent, TranslocoDirective],
	templateUrl: './register-button.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './register-button.component.css'
})
export class RegisterButtonComponent {
	readonly block = input(false)

	constructor(
		public siteConfigService: SiteConfigService,
		private router: Router
	) {}

	public handleRegisterClick(): void {
		this.router.navigate([appPages.register.href])
	}
}
